<template>
  <div
    v-if="props.customisedProduct.measurements"
    :class="bem()"
  >
    <span :class="bem('divider')" />
    <template
      v-for="spec in computedMeasurements"
      :key="spec"
    >
      <ProductSpecificationItem
        v-if="spec.type === 'spec' && spec.title && spec.value"
        :title="spec.title"
        :value="spec.value"
        :tooltip="spec.tooltip"
        :number="spec.number"
      />
      <DatoCmsImage
        v-else-if="spec.type === 'image' && spec.image?.responsiveImage"
        :data="spec.image?.responsiveImage"
        layout="cover"
        :class="bem('image')"
        sizes="(max-width: 1280px) 100vw, 40vw"
      />
      <span
        v-if="spec.value || spec.image"
        :class="bem('divider')"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'
import CustomisedProduct from '~/models/CustomisedProduct'

const bem = useBEM('ProductSpecificationMeasurements')

const props = defineProps({
  customisedProduct: { type: CustomisedProduct, required: true },
})

const computedMeasurements = computed(() => {
  return {
    weight: {
      type: 'spec',
      title: 'Weight',
      value:
        props.customisedProduct.measurements?.weight &&
        `${props.customisedProduct.measurements.weight} grams`,
      tooltip: '',
      number: '',
      image: null,
    },
    frontView: {
      type: 'image',
      title: '',
      value: '',
      tooltip: '',
      number: '',
      image: images.value.front,
    },
    frameHeight: {
      type: 'spec',
      title: 'Height (Including Frame)',
      value:
        props.customisedProduct.measurements?.heightFrame &&
        `${props.customisedProduct.measurements.heightFrame} mm`,
      tooltip: '',
      number: '',
      image: null,
    },
    frameLength: {
      type: 'spec',
      title: 'Length (Frame)',
      value:
        props.customisedProduct.measurements?.lengthFrame &&
        `${props.customisedProduct.measurements.lengthFrame} mm`,
      tooltip: '',
      number: '',
      image: null,
    },
    sideView: {
      type: 'image',
      title: '',
      value: '',
      tooltip: '',
      number: '',
      image: images.value.side,
    },
    lensHeight: {
      type: 'spec',
      title: 'Height (Lens)',
      value:
        props.customisedProduct.measurements?.heightLenses &&
        `${props.customisedProduct.measurements.heightLenses} mm`,
      tooltip: '',
      number: '',
      image: null,
    },
    lensWidth: {
      type: 'spec',
      title: 'Width (Lens)',
      value:
        props.customisedProduct.measurements?.widthLenses &&
        `${props.customisedProduct.measurements.widthLenses} mm`,
      tooltip: '',
      number: '',
      image: null,
    },
  }
})

const images = computed(() => {
  return {
    hero:
      props.customisedProduct.product.pdpConfig?.technicalImageHero ||
      props.customisedProduct.product.baseProduct?.pdpConfig
        ?.technicalImageHero,
    front:
      props.customisedProduct.product.pdpConfig?.technicalImageFront ||
      props.customisedProduct.product.baseProduct?.pdpConfig
        ?.technicalImageFront,
    side:
      props.customisedProduct.product.pdpConfig?.technicalImageSide ||
      props.customisedProduct.product.baseProduct?.pdpConfig
        ?.technicalImageSide,
  }
})
</script>

<style lang="postcss">
.ProductSpecificationMeasurements {
  @apply grid gap-3 md:gap-4 pb-6 md:pb-8;
}

.ProductSpecificationMeasurements__divider {
  @apply h-px w-full bg-grey-800;
}
</style>
